export class Status {
    Id: number;
    StatusEN: string;
    StatusAR: string;
};

export class GenericLookup {
    Id :number;
    NameEN :string;
    NameAR :string;
   };